import React from 'react';

const LandingPageContainer = ({ children }) => {
    return (
        <div className='max-w-[90%] lg:max-w-[1400px]  lg:px-[50px] m-auto '>
            {children}
        </div>
    );
};

export default LandingPageContainer;